<template>
  <div v-if="modeData">
    <hr v-if="!noTitle" />
    <h3 v-if="!noTitle">{{ $t('trackers.RecoveryMode') }}</h3>
    <div v-if="modeData.availableModes.includes('recovery')">
      <p>{{ $t('trackers.RecoverymodeDescription') }}</p>

      <div v-if="this.modeData.mode == 'default'">
        <p>{{ $t('trackers.TrackerIsInDefaultMode') }}</p>
        <div v-if="this.modeData.waitingMode == '' || this.modeData.waitingMode == 'default'">
          <McButton v-if="hasPermsForRecoveryMode" @click="setMode('recovery')" variant="outline-secondary" class="mb-2" :icon="'bell'" :text="$t('trackers.EnableRecoveryMode')" />
        </div>
        <div v-else>
          <p>{{ $t('trackers.TrackerIsAwaitingRecoveryMode') }}</p>
          <McButton v-if="hasPermsForRecoveryMode" @click="setMode('default')" variant="outline-secondary" class="mb-2" :icon="'bell-slash'" :text="$t('trackers.SwitchBackToDefaultMode')" />
        </div>
      </div>

      <div v-if="this.modeData.mode == 'recovery'">
        <p>{{ $t('trackers.TrackerIsInRecoveryMode', { date: recoveryModeEndsDateReadable }) }}</p>
        <div v-if="this.modeData.waitingMode == 'recovery'">
          <p>{{ $t('trackers.TrackerIsAwaitingRecoveryExtension') }}</p>
        </div>
        <div v-if="this.modeData.waitingMode == 'default'">
          <p>{{ $t('trackers.TrackerIsAwaitingDefaultMode') }}</p>
        </div>
        <McButton v-if="hasPermsForRecoveryMode && this.modeData.waitingMode != 'recovery'" @click="setMode('recovery')" variant="outline-secondary" class="mb-2" :icon="['far', 'clock']" :text="$t('trackers.ExtendRecoveryMode')" />
        <div v-if="this.modeData.waitingMode != 'default'">
          <McButton v-if="hasPermsForRecoveryMode" @click="setMode('default')" variant="outline-secondary" class="mb-2" :icon="'bell-slash'" :text="$t('trackers.SwitchBackToDefaultMode')" />
        </div>
        <p class="text-danger" v-if="!hasPermsForRecoveryMode">{{ $t('trackers.NoPermissionForRecovery') }}</p>
      </div>
    </div>
    <!--pre> {{ modeData }} </pre-->
  </div>
</template>

<script>
import { dateToLocalizedHumanreadableDate, localizedDatetime } from '../helpers/Time'
import TrackerService from '../services/TrackerService'

export default {
  data() {
    return {
      modeTimer: null,
      modeData: null,
    }
  },
  props: {
    imei: String,
    noTitle: Boolean,
  },
  computed: {
    hasPermsForRecoveryMode() {
      return this.$perms.isAdministrator() || this.$perms.hasPermission(this.imei, 'settings') || this.$perms.hasPermission(this.imei, 'insurerPerms')
    },
    recoveryModeEndsDateReadable() {
      return this.modeData && this.modeData.recoveryModeEnds ? dateToLocalizedHumanreadableDate(localizedDatetime(this.modeData.recoveryModeEnds)) : ''
    },
  },
  watch: {
    imei(val) {
      this.getMode()
    },
  },
  mounted() {
    this.getMode()
    this.modeTimer = setInterval(this.getMode, 10000)
  },
  beforeDestroy() {
    clearTimeout(this.modeTimer)
  },
  methods: {
    setMode(newMode) {
      return TrackerService.setMode(this.imei, newMode).then(
        data => {
          this.modeData = data.mode
          return Promise.resolve(data)
        },
        error => {
          console.error('Error setting tracker mode', error)
          return Promise.reject(error)
        },
      )
    },

    getMode() {
      if (!this.imei) {
        return
      }
      return TrackerService.getMode(this.imei).then(
        data => {
          this.modeData = data.mode
          return Promise.resolve(data)
        },
        error => {
          console.error('Error getting tracker mode', error)
          return Promise.reject(error)
        },
      )
    },
  },
}
</script>
